import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ManagementOfChangeService } from 'app/modules/management-of-change/services/management-of-change.service';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { MocApprovalStatus, MocStatus } from 'app/modules/management-of-change/model';
import module from 'app/modules/management-of-change/moc.module';

@Component({
  selector: 'app-records',
  templateUrl: './moc-record.page.html',
  imports: module,
  standalone: true,
  styleUrls: ['./moc-record.page.scss']
})
export class MocRecordPage {
  private mocId = this.route.snapshot.paramMap.get('id');
  private action = this.route.snapshot.paramMap.get('action');

  public mocForm: FormGroup
  public mocStatus = MocStatus
  public mocApprovalStatus = MocApprovalStatus

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    public location: Location,
    private mocService: ManagementOfChangeService,
  ) { }

  get isViewOnly() {
    return this.action == 'view' ? true : false;
  }

  get wellName(){
    return this.mocForm.get('wellLongName')?.value;
  }

  get status(){
    return this.mocForm.get('status')?.value;
  }

  get approvedStatus(){
    return this.mocForm.get('approvedStatus')?.value;
  }

  ngOnInit() {
    this.mocForm = this.initializeForm()

    this.mocService.getMocRecordById(this.mocId).subscribe((res) => {
      this.mocForm.patchValue({
        id: this.mocId,
        wellStringId: res.data.wellStringId,
        wellStringShortName: res.data.stringShortName,
        wellStringLongName: res.data.stringLongName,
        fieldLongName: res.data.fieldLongName,
        fieldShortName: res.data.fieldLongName,
        wellShortName: res.data.wellShortName,
        wellLongName: res.data.wellLongName,
        platformLongName: res.data.platformLongName,
        platformShortName: res.data.platformShortName,
        stringIndicatorShortName: res.data.stringIndicatorShortName,
        title: res.data.title,
        refNo: res.data.refNo,
        extensionNo: res.data.extNo,
        startDate: handleFormatDate(res.data.startDate,false),
        endDate: handleFormatDate(res.data.endDate, false),
        keyIssues: res.data.keyIssues,
        stage: res.data.stage,
        closeDate: handleFormatDate(res.data.closeDate, false),
        updatedDate: handleFormatDate(res.data.updatedDate, false),
        updatedBy: res.data.updatedBy,
        requestedBy: res.data.requestBy,
        status: res.data.status,
        approvedStatus: res.data.approvalStatus,
        remarks: res.data.remarks
      })
      
      // this.initialFormValues = { ...this.cmForm.getRawValue() }
    })
  }

  initializeForm() {
    return this.fb.group({
      id: this.mocId,
      wellStringId: '',
      wellStringShortName: [{ value: '', disabled: true }],
      wellStringLongName: [{ value: '', disabled: true }],
      fieldLongName: [{ value: '', disabled: true }],
      fieldShortName: [{ value: '', disabled: true }],
      platformLongName: [{ value: '', disabled: true }],
      platformShortName: [{ value: '', disabled: true }],
      wellLongName: [{ value: '', disabled: true }],
      wellShortName: [{ value: '', disabled: true }],
      stringIndicatorShortName: [{value: '', disabled: true}],
      title: [{ value: '', disabled: this.isViewOnly }],
      refNo: [{ value: '', disabled: this.isViewOnly }],
      extensionNo: [{ value: '', disabled: this.isViewOnly }],
      startDate: [{ value: new Date().toISOString(), disabled: this.isViewOnly }],
      endDate: [{ value: new Date().toISOString(), disabled: this.isViewOnly }],
      keyIssues: [{ value: '', disabled: true }],
      stage: [{ value: '', disabled: true }],
      closeDate: [{ value: new Date().toISOString(), disabled: this.isViewOnly }],
      updatedBy: [{ value: '', disabled: this.isViewOnly }],
      updatedDate: [{ value: new Date().toISOString(), disabled: this.isViewOnly }],
      requestedBy: [{ value: '', disabled: true }],
      status: [{ value: '', disabled: true }],
      approvedStatus: [{ value: '', disabled: true }],
      remarks: [{ value: ''}],
    })
  }

  save(){
    let payload = {
      id: this.mocForm.get('id').value,
      remarks: this.mocForm.get('remarks').value
    }

    this.mocService.updateMocRecord(payload).subscribe()
  }

}


